import React from 'react'
import { ButtonRound, Container, Content, Line } from './styles'

import { FaBarsStaggered, FaChevronLeft, FaChevronRight, FaGear } from 'react-icons/fa6'
import { useLocation } from 'react-router-dom'
import { Row } from '../commons'
import { useNavigate } from 'react-router-dom'
import { useDirectory } from '../../store/directory'
import { ButtonIcon } from '../Table/Pagination/styles'

export interface HeaderProps {
  title?: string
  handleModal: () => void
}

const Header: React.FunctionComponent<HeaderProps> = ({ handleModal }) => {
  const nav = useNavigate()
  const location = useLocation()
  const { directory, history, setDirectory, setHistory } = useDirectory((state) => state)

  const goBack = () => {
    if (location.pathname !== '/documents') {
      nav(-1)
    } else {
      if (directory.length > 1) {
        setHistory(directory)

        let dir = [...directory]
        dir.pop()

        setDirectory(dir)
      }
    }
  }
  const goFoward = () => {
    if (location.pathname !== '/documents') {
      nav(1)
    } else {
      let historyAux = history

      setDirectory(historyAux)
      setHistory(directory)
    }
  }

  return (
    <Container>
      <Content>
        <Row style={{ gap: 10, height: '100%' }}>
          <ButtonRound onClick={goBack}>
            <FaChevronLeft color={'white'} size={15} />
          </ButtonRound>
          <ButtonRound onClick={goFoward}>
            <FaChevronRight color={'white'} size={15} />
          </ButtonRound>
          <Line />

          <ButtonIcon onClick={handleModal}>
            <FaBarsStaggered size={25} />
          </ButtonIcon>
          <Line />
        </Row>
        <Row style={{ gap: 10, height: '100%' }}>
          <ButtonIcon onClick={() => nav('/config')}>
            <FaGear size={25} />
          </ButtonIcon>
        </Row>
      </Content>
    </Container>
  )
}

export default Header
